'use client'

import { useUserStore } from '@/stores/user-store-provider'
import { useEffect, useState } from 'react'
import { twoDecimal } from '@/utils/index'

interface CurrencyPriceProps {
  priceDiscount: number // HK$ 折扣价格
  type?: string
}

export default function CurrencyPrice({ priceDiscount, type }: CurrencyPriceProps) {
  const { currencySign, exchangeRate } = useUserStore((state) => state)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  // 避免水合不匹配，在客户端挂载前显示默认值
  if (!mounted) {
    return <span>{`(${currencySign}${priceDiscount}) `}</span>
  }

  const convertedPriceDiscount = twoDecimal(priceDiscount * exchangeRate)

  return type === 'bookDetail' ? (
    <>
      <span className="text-[16px]">{`(`}</span>
      <span className="text-[16px]">{`${currencySign}`}</span>
      <span className="text-[5px]">&nbsp;</span>
      <span className="text-[16px]">{`${convertedPriceDiscount})`}</span>
    </>
  ) : (
    <>
      <span>{`(${currencySign}`}</span>
      <span className="!text-[5px]">&nbsp;</span>
      <span>{`${convertedPriceDiscount})`}</span>
    </>
  )
}
